import { render, staticRenderFns } from "./tickets-picker.component.vue?vue&type=template&id=b2bb9cea"
import script from "./tickets-picker.component.vue?vue&type=script&lang=js"
export * from "./tickets-picker.component.vue?vue&type=script&lang=js"
import style0 from "./tickets-picker.component.vue?vue&type=style&index=0&id=b2bb9cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports